import { Component, Optional } from "@angular/core";
import { AutoSaveState } from "@mipro/classes/auto-save";
import { AutoSaveDirective } from "@mipro/directives";

@Component({
    selector: "form-state",
    template: `
        <ng-container [ngSwitch]="state.type">
            <ng-container *ngSwitchCase="'saving'">
                <i class="pi pi-spin pi-sync"></i>
            </ng-container>
            <ng-container *ngSwitchCase="'success'">
                <i class="pi pi-check"></i>
            </ng-container>
            <ng-container *ngSwitchCase="'failure'">
                <i
                    *ngIf="state.errorMessage; else noErrorMessage"
                    class="pi pi-exclamation-circle"
                    [pTooltip]="state.errorMessage"
                    tooltipPosition="top"
                    [style.cursor]="'pointer'">
                </i>
                <ng-template #noErrorMessage>
                    <i class="pi pi-exclamation-circle"></i>
                </ng-template>
            </ng-container>
            <ng-container *ngSwitchDefault></ng-container>
        </ng-container>
    `
})
export class FormStateComponent {
    state: AutoSaveState = { type: "idle" };

    private registered = false;

    constructor(@Optional() autoSaveDirective: AutoSaveDirective) {
        this.register(autoSaveDirective);
    }

    private register(autoSaveDirective: AutoSaveDirective) {
        if (this.registered || !autoSaveDirective) {
            return;
        }

        autoSaveDirective.registerState(this);
        this.registered = true;
    }
}
